import { Theme } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/material/styles";

export const ShipmentStatusWrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: 8,
}));

export const ShipmentStatusTitle = styled("span")(() => ({
  color: "#465869",
  fontSize: "0.875rem",
  fontWeight: 600,
  fontFamily: "Manrope",
}));

const styles = makeStyles((theme: Theme) => ({
  mainDiv: {
    padding: "16px 32px",
  },
  tabDetails: {
    // padding: "24px !important",
    padding: "0px !important",
  },
  customerContainerTabs: {
    display: "flex",
    position: "relative",
    flexDirection: "row",
    width: "100%",
    gap: "12px",
  },
  uiTab: {
    height: "100% !important",
  },
  mr8: {
    marginRight: 8,
  },
  descriptionModalConfirm: {
    display: "flex",
    gap: "0.7rem",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column",
    "& span": {
      fontFamily: "Inter",
      fontStyle: "normal",
      fontWeight: "400",
      fontSize: "16px",
      lineHeight: "24px",
    },
    "& .error": {
      color: "#F04438",
      fontStyle: "italic",
    },
  },
  shipmentsHeader: {
    marginBottom: 24,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    background: "#F8FAFC",
    boxShadow: "inset 0px -1px 0px #F0F0F0",
    padding: "20px 32px 20px 40px",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      alignItems: "flex-start",
      "&:nth-last-child(n)": {
        marginTop: "8px",
      },
    },
  },
  shipmentStatus: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  shipmentStatusTitle: {
    color: "#465869",
    fontSize: "14px",
    fontWeight: "bold",
  },
}));

export default styles;
